import { getId } from '@src/containers/UtmGenerator/helpers'

export const TrafficData = [
  {
    id: getId(),
    text: 'Свой',
    name: 'yourValues'
  },
  {
    id: getId(),
    text: 'Яндекс Директ',
    name: 'yandexDirect'
  },
  {
    id: getId(),
    text: 'Google Ads',
    name: 'googleAds'
  },
  {
    id: getId(),
    text: 'VK Реклама',
    name: 'vkAds'
  },
  {
    id: getId(),
    text: 'ВКонтакте',
    name: 'vkontakte'
  },
  {
    id: getId(),
    text: 'myTarget',
    name: 'mytarget'
  }
]
